import { render, staticRenderFns } from "./addCity.vue?vue&type=template&id=676b766c&scoped=true"
import script from "./addCity.vue?vue&type=script&lang=js"
export * from "./addCity.vue?vue&type=script&lang=js"
import style0 from "./addCity.vue?vue&type=style&index=0&id=676b766c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676b766c",
  null
  
)

export default component.exports